module.exports = __webpack_public_path__ + "static/media/alibi-logo.0cae2e0c.png";